export const APP_TOKENS = {
  color: {
    background: "#F7F8FB",
    surface: "#FFFFFF",
    surfaceMuted: "#F4F7FC",
    surfaceAccent: "#EEF9FD",
    border: "#E2E7F0",
    borderStrong: "#C4C6CD",
    textPrimary: "#1E2533",
    textSecondary: "#4A5161",
    textMuted: "#6B7280",
    accent: "#00B7F4",
    accentDark: "#00759B",
    accentMuted: "#C4EEFD",
    inverse: "#FFFFFF",
    successSurface: "#ECFDF3",
    successBorder: "#A6F4C5",
    successText: "#067647",
    errorSurface: "#FFF2F1",
    errorBorder: "#FFD8D4",
    errorText: "#A41313",
    overlay: "rgba(30, 37, 51, 0.56)",
    overlayBlack: "rgba(0, 0, 0, 0.5)",
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 24,
    xxxl: 32,
    huge: 40,
    massive: 48,
    giant: 64,
  },
  radius: {
    sm: 4,
    md: 8,
    button: 10,
    lg: 12,
    xl: 16,
    xxl: 24,
    round: 999,
  },
  borderWidth: {
    thin: 1,
    strong: 2,
  },
  shadow: {
    card: {
      shadowColor: "#1E2533",
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.08,
      shadowRadius: 16,
      elevation: 3,
    },
  },
  font: {
    regular: "Urbanist400",
    medium: "Urbanist500",
    semibold: "Urbanist600",
    bold: "Urbanist700",
  },
  fontSize: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    xxl: 24,
    xxxl: 32,
  },
  lineHeight: {
    xs: 16,
    sm: 20,
    md: 22,
    lg: 24,
    xl: 28,
    xxl: 32,
    xxxl: 40,
  },
  letterSpacing: {
    caps: 1,
  },
  zIndex: {
    base: 1,
    above: 10,
  },
  motion: {
    fast: 100,
    standard: 200,
    slow: 300,
  },
  opacity: {
    disabled: 0.55,
    mutedMedia: 0.72,
    pressed: 0.78,
  },
} as const;
